import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import useMerchandiseCategories from 'hooks/Merchandise/useMerchandiseCategories'
import MerchandiseMegaMenuPanel from './MerchandiseMegaMenuPanel'
import { getMerchandiseCategorySearchUrl } from '../../merchandiseUtils'
import { merchandiseMegaMenuBreakpoints } from './merchandiseMegaMenuBreakpoints'
import { useMegaMenuTracking } from 'analytics/snowplow/events/megaMenuEvents'

const Container = styled(MerchandiseMegaMenuPanel)`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  padding: ${rem(24)};

  ${merchandiseMegaMenuBreakpoints.mediumLarge} {
    padding: ${rem(24)};
  }
`

const StyledClickableListItem = styled(ClickableListItem)`
  && {
    padding-block: ${rem(8)};
    padding-inline: ${rem(12)};
  }
`

interface Props {
  category?: App.MerchandiseCategory
  onClose: () => void
}

function MerchandiseMegaMenuSubcategoryList(props: Props) {
  const { category, onClose } = props
  const intl = useIntl()
  const trackSubcategoryClick = useMegaMenuTracking('subcategory', onClose)

  const [subcategories] = useMerchandiseCategories({
    categoryIds: category?.childCategoryIds || [],
  }, { disabled: !category })

  if (!category) {
    return <Container />
  }

  return <Container>
    <StyledClickableListItem
      to={getMerchandiseCategorySearchUrl(category)}
      onClick={() => trackSubcategoryClick({ id: category.id, name: `All ${category.name}` }, 0)}
      title={intl.formatMessage(
        {
          id: 'aNgT0Ils2W',
          defaultMessage: 'All {categoryName}',
          description: 'Link text to view all items in a category',
        },
        { categoryName: category.name },
      )}
      titleColour="neutral-one"
      titleWeight="bold"
      size="medium"
    />
    {subcategories.map((subcategory, index) => (
      <StyledClickableListItem
        key={subcategory.id}
        to={getMerchandiseCategorySearchUrl(subcategory)}
        onClick={() => trackSubcategoryClick(subcategory, index + 1)}
        title={subcategory.name}
        titleColour="neutral-one"
        size="medium"
      />
    ))}
  </Container>
}

export default MerchandiseMegaMenuSubcategoryList
